// extracted by mini-css-extract-plugin
module.exports = {"simpleHeader":"styles_simpleHeader__NVu2j","titleHeader":"styles_titleHeader__4Wr35","menuCredito":"styles_menuCredito__2YlKJ","notif":"styles_notif__1RwFm"};